/**
 * @flow
 * @format
 */

/*
 * https://github.com/npbee/react-redux-saga-validation-example/blob/master/src/createValidator.js
 */

import _ from 'lodash';
// import rules from './validators';

type SpecType = {
  message: string | Function,
  params: Array<*>,
  test(val: any, ...args: Array<any>): boolean,
};

export type ValidatorType = {
  message?: string | Function,
  report?: string | Function,
  test?: Function,
};

const initialSpec = {
  message: '',
  params: [],
  test: () => true,
};

export default function createValidator(
  spec: SpecType = initialSpec /* state: {} = {} */,
): any {
  // If we're given a string like 'minLength:3', we can see if it exists in
  // our globally defined rules.
  // if (typeof spec === 'string') {
  //   const [name, params] = spec.split(':');
  //   const rule = rules[name];

  //   if (rule) {
  //     return createValidator({
  //       ...rule,
  //       params,
  //     },
  //     state);
  //   }
  // }

  const { test = () => true, message = '', params = [] } = spec;

  const args = _.castArray(params);

  return {
    test(value: any) {
      // $FlowIgnore
      return test(value, ...args);
    },
    report(value: any): string {
      if (typeof message === 'function') return message(value, ...args);
      return message;
    },
  };
}



// WEBPACK FOOTER //
// ./src/utils/createValidator.js